<template>
  <div>
    <div
      ref="textarea"
      class="px-3 py-2 w-full bg-white overflow-auto max-h-24"
      contenteditable
      @keydown="handleKeydown"
      @paste="pasteText"
    />
  </div>
</template>

<script>
export default {
  methods: {
    handleKeydown(ev) {
      if (ev.which === 13 && ev.shiftKey === false) {
        this.$emit('change', ev.target.innerText);
        // eslint-disable-next-line no-param-reassign
        ev.target.innerText = '';
        ev.preventDefault();
        return;
      }

      this.scrollToBottom(ev);
    },
    scrollToBottom(ev) {
      // eslint-disable-next-line no-param-reassign
      setTimeout(() => {
        ev.target.scrollTop = ev.target.scrollHeight;
      }, 0);
    },
    pasteText(ev) {
      const paste = (ev.clipboardData || window.clipboardData).getData('text');
      const selection = window.getSelection();
      if (!selection.rangeCount) return;
      selection.deleteFromDocument();
      selection.getRangeAt(0).insertNode(document.createTextNode(paste));

      ev.preventDefault();
    },
  },
};
</script>
